import { render, staticRenderFns } from "./CompanyViewLauout.vue?vue&type=template&id=2726d67c&"
import script from "./CompanyViewLauout.vue?vue&type=script&lang=js&"
export * from "./CompanyViewLauout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports